module.exports = __webpack_public_path__ + "static/circuit-board-5ea371567ae4f0c31a5412c71e882f68.png";